import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rbtFilter'
})
export class RbtFilterPipe implements PipeTransform {

  transform<T extends { cpt?: string }>(services: T[] | null | undefined): T[] | null | undefined {
    if (!services) {
      return services;
    }
    return services.filter(service => service.cpt?.startsWith('97153'));
  }

}


